import { baseAPI } from "../../baseApi";
import { tagsTypes } from "../../tagsTypes";

export const supplierTypeSlice = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    postSupplierSaveType: builder.mutation({
      query: (data) => ({
        url: "supplier-save-type",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_USER_PROFILE],
    }),
  }),
});

export const { usePostSupplierSaveTypeMutation } = supplierTypeSlice;
